import type { BaseUserDTO } from '@repositories/workflowRepository/workflow.types';

export default class BaseUserDTOModel {
  private readonly _dto: BaseUserDTO;

  constructor(dto: BaseUserDTO) {
    this._dto = dto;
  }

  get originDTO(): BaseUserDTO {
    return this._dto;
  }

  get id(): string {
    return this._dto.id || '';
  }

  get name(): string {
    return this._dto.name || '';
  }

  get username(): string {
    return this._dto.username || '';
  }
}
